export const stats = [
    {
        id:1,
        img:"./assets/star.svg",
        title:"Rewards",
        content:"The best credit card offer some tantalizing combinations of promotions and prizes"
    },
    {
        id:2,
        img:"./assets/shield.svg",
        title:"100% Secured",
        content:"We take proactive steps make sure your informations and transactions are secure."
    },
    {
        id:3,
        img:"./assets/send.svg",
        title:"Balance Transfer",
        content:"A balance transfer credit card can save you alot of money in interest charges"
    }
]


export const testmonials = [
    {
        id:1,
        symbol:'"',
        text:'Money is only a tool.It will take you whereever you wish,but it will not replace you as the driver.',
        img:'./assets/people01.png',
        name:'Herman Jonson',
        role:'Founder & Leader'

    },
    {
        id:2,
        symbol:'"',
        text:"Money makes your life easier.if you're lucky to have it, you are lucky to be among the few selected ones",
        img:'./assets/people02.png',
        name:'Steve Mark',
        role:'Founder & Leader'

    },
    {
        id:3,
        symbol:'"',
        text:'It is usually people in the money business,finance and international trade that are really rich..',
        img:'./assets/people03.png',
        name:'Kenn Gallaghor',
        role:'Founder & Leader'

    }
]